import styled from 'styled-components';
import { InputNumber } from 'antd';

const EbzInputNumber = styled(InputNumber)`
  .ant-input-number .ant-input-number-input {
    background-color: #00000000;
  }
  .ant-input-number-disabled {
    background-color: #00000000;
  }

  .ant-input-number-disabled .ant-input-number-input-wrap .ant-input-number-input {
    color: #00000040;
  }
`;

export default EbzInputNumber;
